/**
 * Given an entity (as object or as a pure ID) this function returns only the ID parsed to string
 * @param {any} target
 * @returns {string} Id
 */

function getEntityId(target) {
  if (!target) return undefined
  if (typeof target === 'object' && !target._id && !target.id) return null

  if (target._id)
    return target._id.toString ? target._id.toString() : target._id
  if (target.id) return target.id.toString ? target.id.toString() : target.id
  return target.toString ? target.toString() : target
}

module.exports = getEntityId
